import { makeAutoObservable } from 'mobx';
import {daysFromNow} from 'shared/tools';

class PayrollDatesState {
  emojiReady;

  payPeriod;

  constructor() {
    makeAutoObservable(this, {
      emojiReady: false
    });
  }

  receiveProps({payPeriod, emojiReady}) {
    this.payPeriod = payPeriod;
    this.emojiReady = emojiReady;
  }

  get cutoffWarningDateDaysFromNow() {
    return daysFromNow(this.payPeriod.cutoffWarningDate);
  }

  get payDateDaysFromNow() {
    return daysFromNow(this.payPeriod.payDate);
  }

  get cutoffWarningDateColour() {
    switch (this.cutoffWarningDateDaysFromNow) {
      case 2:
        return 'sun';
      case 1:
      case 0:
        return 'scarlet';
      default:
        return null;
    }
  }

  get payPeriodToArray() {
    return [
      {
        dateName: 'Payroll Data Submission Cutoff',
        date: this.payPeriod.cutoffWarningDate,
        daysFromNow: this.cutoffWarningDateDaysFromNow,
        colour: this.cutoffWarningDateColour
      },
      {
        dateName: 'Next Pay Date',
        date: this.payPeriod.payDate,
        daysFromNow: this.payDateDaysFromNow
      }
    ];
  }
}

export default PayrollDatesState;
